// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3pmyE","content":"styles_content__3X3ME","checkbox":"styles_checkbox__1xe8c","checkboxLabel":"styles_checkboxLabel__2pA6l"};